import { isArabicUi } from "@/shared/config/arabicUi";

/**
 * «Создайте план тренировок — и тренировки начнут приносить баллы» (владелец 11.10, пункт 3):
 * подсказка там, где человек видит свои баллы «Тренировок», — только ему самому и только когда
 * действующего плана нет. Слова — те же, что в напоминании сервера (services_fastapi.plan_reminder)
 * и в приложении: минимально, без условий.
 *
 * ru, en, de, es, cn (zh), ar — при включённом арабском интерфейсе (иначе /ar, как весь сайт, —
 * английский); прочие — английский.
 */
export type PlanHintLang = "ru" | "en" | "de" | "es" | "zh" | "ar";

export interface PlanHintTexts {
    /** Строка подсказки. */
    text: string;
    /** Кнопка — в конструктор плана. */
    go: string;
}

const TEXTS: Record<PlanHintLang, PlanHintTexts> = {
    ru: { text: "Создайте план тренировок — и тренировки начнут приносить баллы", go: "Составить план" },
    en: { text: "Create a workout plan — and your workouts will start earning points", go: "Build a plan" },
    de: { text: "Erstellen Sie einen Trainingsplan — und Ihre Trainings bringen Punkte", go: "Plan erstellen" },
    es: { text: "Crea un plan de entrenamiento y tus entrenamientos empezarán a sumar puntos", go: "Crear un plan" },
    zh: { text: "制定训练计划——你的训练就会开始获得积分", go: "制定计划" },
    ar: { text: "أنشئ خطة تمارين — وستبدأ تمارينك في جلب النقاط", go: "إعداد خطة" },
};

export const planHintLang = (siteLang: string | null | undefined): PlanHintLang => {
    const l = String(siteLang || "").toLowerCase();
    if (l === "cn" || l === "zh") return "zh";
    if (l === "ar") return isArabicUi(l) ? "ar" : "en";
    if (l === "ru" || l === "en" || l === "de" || l === "es") return l;
    return "en";
};

export const planHintTexts = (siteLang: string | null | undefined): PlanHintTexts => TEXTS[planHintLang(siteLang)];

/** Все словари — для проверки покрытия. */
export const PLAN_HINT_TEXTS: Readonly<Record<PlanHintLang, PlanHintTexts>> = TEXTS;
